import { useState } from "react";

export default function ValentineCard() {
  const [yesClicked, setYesClicked] = useState(false);
  const [noPos, setNoPos] = useState({ top: "65%", left: "55%" });
  const [noCount, setNoCount] = useState(0);

  const noTexts = [
    "NO 😅",
    "STOP 😭",
    "WHY 😩",
    "PLEASE 🥲",
    "OK FINE 😤",
    "STILL NO 💀"
  ];

  const moveNo = () => {
    const minX = 5;
    const maxX = 85;
    const minY = 45;
    const maxY = 85;

    const x = Math.random() * (maxX - minX) + minX;
    const y = Math.random() * (maxY - minY) + minY;

    setNoPos({
      left: `${x}%`,
      top: `${y}%`,
      transform: `rotate(${Math.random() * 24 - 12}deg)`
    });

    setNoCount((prev) => prev + 1);
  };

  return (
    <div className="card">
      {!yesClicked ? (
        <>
          <h1>Will you be my Valentine? 💖</h1>
          <p>Every love story is beautiful, but ours could be my favorite ✨</p>

          <div className="buttons">
            <button className="yes" onClick={() => setYesClicked(true)}>
              YES 💘
            </button>

            <button
              className="no"
              style={noPos}
              onMouseEnter={moveNo}
            >
              {noTexts[noCount % noTexts.length]}
            </button>
          </div>
        </>
      ) : (
        <div className="success">
          <div className="heart-big">❤️</div>
          <h2>You just made my heart skip a beat 💓</h2>
          <p>Happy Valentine’s Day 😘</p>
        </div>
      )}
    </div>
  );
}
